import styled from "styled-components";

export const BlackContainer = styled.div`
    width: 368px;
    min-height: 500px;

    box-sizing: border-box;

    background-color: #262626;
    color: white;

    border-radius: 16px;
`